export enum ReferralUpdatedBy {
  'AWS' = 'AWS',
  'LABRA_CRM' = 'Labra CRM',
}

export type ReferralMetadataType = 'referral_lead' | 'referral_opportunity'
